import {getWithExpiry} from './Functions'

export const isAuthenticated = () => {
    const token = getWithExpiry('@oee-monitor/expiry')
    if (token === null)
        return false
    return true
}